import { useState, useEffect } from "react";
import Loader from "./components/Loader.js";
const withLoader = (Component) => (props) => {
  const [loading, setLoading] = useState(false);

  const startLoading = () => setLoading(true);
  const endLoading = () => setLoading(false);
  return loading ? (
    <Loader />
  ) : (
    <Component
      {...props}
      loading={loading}
      startLoading={startLoading}
      endLoading={endLoading}
    />
  );
};

export default withLoader;
